//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'cell-row',
  props: {
    title: {
      type: String,
    },
    content: {
      type: String,
    },
    alignItems: {   // flex子元素内容垂直方向对齐方式
      type: String,
      default: 'center'
    },
    setBorder: {    // 设置边框
      type: Boolean,
      default: true,
    },
    leftSpan: {     // 左侧flex的值
      type: Number,
      default: 4,
    },
    rightSpan: {    // 右侧flex的值
      type: Number,
      default: 7,
    },
    isLink: {       // 为true右侧带箭头
      type: Boolean,
      default: false,
    },
    // 取pt单位的两倍
    padding: {      // 上下内边距
      type: Number,
      default: 36,
    },
  },
  methods: {
    onLink(){
      this.$emit('on-link');
    }
  },
}



// WEBPACK FOOTER //
// ./src/components/Cell/CellRow.vue